// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.svg-icon[data-v-131e9d20] {\r\n  /* width: 1em;\r\n  height: 1em; */\r\n  vertical-align: -0.15em;\r\n  fill: currentColor;\r\n  overflow: hidden;\n}\r\n\r\n/* .svg-external-icon {\r\n  background-color: currentColor;\r\n  mask-size: cover !important;\r\n  display: inline-block;\r\n} */\r\n", ""]);
// Exports
module.exports = exports;
